var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "One-Finger-Tap--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "One Finger Tap Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "one-finger-tap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 107",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.1015 13.5 0 -2.8332c0 -1.42108 -1.152 -2.57305 -2.57302 -2.57305l-2.2348 0 0 -4.17552c0 -0.66393 -0.53822 -1.20214 -1.20214 -1.20214v0c-0.66393 0 -1.20214 0.53821 -1.20214 1.20214l-0.00001 5.47348 -0.40088 0.07545C3.2696 9.69655 2.68954 11.1039 3.3928 12.1255l0.16169 0.2349 0.78347 1.1396",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 302",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.59749 4.93236c-0.06138 -0.26386 -0.09383 -0.53882 -0.09383 -0.82137C2.50366 2.1167 4.12036 0.5 6.11465 0.5c1.9943 0 3.61099 1.6167 3.61099 3.61099 0 0.28255 -0.03245 0.55751 -0.09382 0.82137",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerIcon);
export default __webpack_public_path__ + "static/media/finger-icon.3a83e89cc89c401cb5e96909f012a16d.svg";
export { ForwardRef as ReactComponent };